"use strict";
define(
'stores/classes',[
	"jquery",
	"underscore",
	"stores/store",
	"constants/actiontypes",
	"xregexp"
],
function ($, _, StoreBase, Constants, XRegExp)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);
		
		// Setup the instance
		this.classes = {};
		this.registerDispatchListener(function (action) {
			var self = this;
			switch(action.actionType) {
				case Constants.CREATED_CLASS:
					if(!this.classes)
						this.classes = {};

					if(Array.isArray(action.data)) {
						_.each(action.data, function (data) {
							self.addClass(data);
						});
					}
					else {
						this.addClass(action.data);
					}
					this.event.emit("change");
					break;
				case Constants.UPDATED_CLASS:
					if(this.classes[action.guid]) {
						_.each(action.data, function(value, key) {
							self.classes[action.guid][key] = value;
						});
						this.event.emit("change");
					}
					else {
						console.log("Error - Section doesn't exist.");
					}
					break;
				case Constants.ENROLL_STUDENT_CLASS:
					this.addClass(action.data);
					this.event.emit("change");
					break;
				case Constants.DISENROLL_STUDENT_CLASS:
					this.addClass(action.data);
					this.event.emit("change");
					break;
			}
		}.bind(this));

		// Init filter
		this.status = true;
		this.keyword = "";
	}

	Store.prototype.addClass = function (data)
	{
		this.classes[data.id] = data;
	}

	Store.prototype.get = function (id)
	{
		if(!this.classes) 
			return null;

		return this.classes[id];
	}

	Store.prototype.getOrPull = function(id) {
		if(!this.classes || !this.classes[id]) {
			var Actions = require("shared/connect-to-actions");
			Actions.classes.pull(id);
			return null;
		}

		return this.classes[id];
	}

	Store.prototype.getAll = function (filterOptions)
	{
		if(!this.classes)
			return null;

		var classes;
		if(filterOptions) {
			var keywordRegExp = null;

			if(filterOptions.keyword && filterOptions.keyword.trim().length >= 3) {
				// Trim all spaces from beginning and ending
				var keyword = filterOptions.keyword.trim();

				// Make a regular expression to allow all characters, numerics, and spaces
				var allowCharacterSets = XRegExp("[^\\pL\\s\\d]+", "g");

				// Replace all special characters as nothing and space as OR("|")
				keyword = XRegExp.replace(keyword, allowCharacterSets, "");
				keyword = keyword.trim().replace(/\s+/g, "|");

				keywordRegExp = new RegExp(keyword, "i");
			}

			classes = _.filter(this.classes, function(section) {
				if(filterOptions.status != null) {
					var status = filterOptions.status == "active" ? 1 : 0;
					if(section.status != status)
						return;
				}

				if(keywordRegExp && !keywordRegExp.test(section.name) && !keywordRegExp.test(section.code))
					return;

				if(filterOptions.code && filterOptions.code != section.code) {
					return;
				}

				return section;
			});
		}
		else {
			classes = _.map(this.classes, function(section) {
				return section;
			});
		}

		return classes;
	}

	Store.prototype.getCount = function ()
	{
		return Object.keys(this.classes).length;
	}

	Store.prototype.getFilters = function() {
		if(this.status == null && this.keyword == "")
			return null;
		return { keyword: this.keyword, status: this.status };
	}

	return Store;
});
